import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import Icon from '@/app/components/Icon';
import { imageTypes } from '@/constants/types';
import CounterBadge from './CounterBadge';
import ImageComponentV2 from '../Image/ImageComponentV2';

function TimerFlash({ targetStartDate, targetEndDate }) {
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    if (targetStartDate && targetEndDate) {
      const normalizeDate = (dateStr) =>
        dateStr.length === 16 ? `${dateStr}:00` : dateStr;

      const newStart = new Date(normalizeDate(targetStartDate));
      const newEnd = new Date(normalizeDate(targetEndDate));

      if (Number(newStart) && Number(newEnd)) {
        setStart(newStart);
        setEnd(newEnd);
      }
    }
  }, [targetStartDate, targetEndDate]);

  useEffect(() => {
    if (!start) return;
    const now = Date.now();
    if (now >= start.getTime()) {
      setIsStarted(true);
    } else {
      const timeUntilStart = start.getTime() - now;
      const timeoutId = setTimeout(() => {
        setIsStarted(true);
      }, timeUntilStart);

      return () => clearTimeout(timeoutId);
    }
  }, [start]);

  if (!isStarted || !end) {
    return (
      <div
        role="button"
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
        className="bg-white min-w-[128px] flex gap-1 px-4 lg:px-6 py-4 rounded-8 shadow-trending-categories-search cursor-auto"
      >
        <ImageComponentV2
          src="/icons/clock.svg"
          alt="clock icon"
          className="size-[24px] lg:size-[32px]"
          width={32}
          height={32}
          type={imageTypes.icon}
          loading="lazy"
        />
        <Icon type="clock" className="size-[24px] lg:size-[32px]" />
        <div className="flex gap-[3px] lg:gap-[6px]">
          <CounterBadge count="00" label="Day" />
          <CounterBadge count="00" label="Hr" />
          <CounterBadge count="00" label="Min" />
          <CounterBadge count="00" label="Sec" />
        </div>
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={-1}
      onClick={(e) => e.stopPropagation()}
      className="bg-white min-w-[128px] flex gap-1 px-4 lg:px-6 py-4 rounded-8 shadow-trending-categories-search cursor-auto"
    >
      <ImageComponentV2
        src="/icons/clock.svg"
        alt="clock icon"
        className="size-[24px] lg:size-[32px]"
        width={32}
        height={32}
        type={imageTypes.icon}
        loading="lazy"
      />
      <Countdown
        key={`${targetStartDate}-${targetEndDate}`}
        date={end.getTime()}
        renderer={({ days, hours, minutes, seconds }) => (
          <div className="flex gap-[3px] lg:gap-[6px]">
            <CounterBadge count={String(days).padStart(2, '0')} label="Day" />
            <CounterBadge count={String(hours).padStart(2, '0')} label="Hr" />
            <CounterBadge
              count={String(minutes).padStart(2, '0')}
              label="Min"
            />
            <CounterBadge
              count={String(seconds).padStart(2, '0')}
              label="Sec"
            />
          </div>
        )}
      />
    </div>
  );
}

export default TimerFlash;
